<script>
import UserManualCard from '@phoenix/components/product/UserManualCard';

export default {
  mixins: [UserManualCard],

  props: {
    label: {
      type: String,
      required: true,
    },
    engravedReference: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
  },

  computed: {
    title() {
      const re = new RegExp(`${this.subtitle} - `, 'g');
      return this.label.replace(re, '');
    },

    subtitle() {
      let subtitle = this.model;
      if (this.engravedReference) {
        subtitle = subtitle.concat(' - ');
      }
      return subtitle.concat(this.engravedReference);
    },

    downloadName() {
      return `${this.$t('UserManual.fileName', {
        product: this.title.replaceAll(' ', '_'),
        lang: this.language.toUpperCase(),
      })}.pdf`;
    },
  },
};
</script>

<template>
  <div class="boutique-card">
    <div class="boutique-card__body">
      <h4 class="boutique-card__name">{{ title }}</h4>
      <div v-if="subtitle" class="boutique-card__address">{{ subtitle }}</div>

      <div class="boutique-card__actions btn-grid">
        <button class="btn btn--default btn--full btn--sm" @click="downloadFile">
          <span class="btn__text">{{ $t('UserManualSearch.download') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>
